import QRCode from 'qrcode';

const createQRCode = (url, { elmId, ...options }) =>
  new Promise(async (resolve, reject) => {
    let qrImage;
    if (elmId && $(`#${elmId}`).length > 0) {
      qrImage = $(`#${elmId}`);
      qrImage.removeAttr('src');
    }

    try {
      const base64 = await QRCode.toDataURL(url, {
        margin: 0,
        width: 300,
        ...options
      });

      if (qrImage) {
        qrImage.attr('src', base64);
      }

      resolve(base64);
    } catch (e) {
      reject(e);
    }
  });

window.createQRCode = createQRCode;
